module.exports = __webpack_public_path__ + "static/media/9-Diamond.0494e858.svg";